import {
    Splide,
} from '@splidejs/splide';
import {
    AutoScroll,
} from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/css';

document.addEventListener('DOMContentLoaded', (event) => {
    const logoCarouselSections = document.querySelectorAll('.logo-awards-carousel-section');

    logoCarouselSections.forEach(section => {
        if (section.classList.contains('logo')) {
            const logoSplideElements = section.querySelectorAll('.logo-carousel');

            logoSplideElements.forEach(logoElement => {
                const logos = logoElement.querySelectorAll('.logo-item');

                if (logos.length > 5) {
                    new Splide(logoElement, {
                        type: 'loop',
                        drag: false,
                        arrows: false,
                        pagination: false,
                        autoWidth: true,
                        autoScroll: {
                            speed: 0.3,
                            pauseOnHover: false,
                        },
                    }).mount({
                        AutoScroll,
                    });
                }
            });
        }

        if (section.classList.contains('awards')) {
            const awardSplideElements = section.querySelectorAll('.award-carousel');

            awardSplideElements.forEach(awardElement => {
                new Splide(awardElement, {
                    type: 'slide',
                    perPage: 4,
                    gap: 32,
                    arrows: true,
                    pagination: false,
                    autoWidth: false,
                    breakpoints: {
                        991: {
                            perPage: 3,
                        },
                        767: {
                            perPage: 2,
                            // arrows: false,
                        },
                    },
                }).mount();
            });
        }
    });
});
